import { CookieSerializeOptions } from 'cookie';
import { CookiesOptions } from 'next-auth';
import { ZXCVBNScore } from 'zxcvbn';

export const YEAR = new Date().getFullYear();

export const HELP_ARTICLE_URL = 'http://ajuda.vnda.com.br/pt-BR/articles/6475213-login-vnda';
export const MFA_ARTICLE_URL =
  'http://ajuda.vnda.com.br/pt-BR/articles/9161130-autenticacao-de-dois-fatores';
export const DIRECT_APP_LINK = 'https://vnda.page.link/WoQJ';
export const VNDA_SUPPORT_EMAIL = 'ajuda@vnda.com.br';

const COOKIE_PREFIX = '_vnda_login_';

export const MFA_COOKIE_NAME = `${COOKIE_PREFIX}mfa`;

export const MFA_SESSION_COOKIE_NAME = `${COOKIE_PREFIX}mfa_session_token`;

export const COOKIE_OPTIONS: CookieSerializeOptions = {
  path: '/',
  secure: process.env.NODE_ENV === 'production',
  sameSite: 'lax',
  httpOnly: true,
};

export const SESSION_COOKIE_SETTINGS: Pick<
  CookiesOptions,
  'sessionToken' | 'callbackUrl' | 'csrfToken'
> = {
  sessionToken: {
    name: `${COOKIE_PREFIX}token`,
    options: COOKIE_OPTIONS,
  },
  callbackUrl: {
    name: `${COOKIE_PREFIX}callback_url`,
    options: COOKIE_OPTIONS,
  },
  csrfToken: {
    name: `${COOKIE_PREFIX}csrf`,
    options: COOKIE_OPTIONS,
  },
};

export const MINIMUM_PASSWORD_SCORE: ZXCVBNScore = 2;

export const GO_TO_SHOP_QUERY = 'goto';
